import React from 'react'
import { useNavigate } from 'react-router-dom'
import PhotoCarousel from '../components/PhotoCarousel'
import GlassPanel from '../components/UI/GlassPanel'
import ProfileBanner from '../components/ProfileBanner'
import EventsTable from '../components/EventsTable'
import EventTimeline from '../components/Timeline/EventTimeline'
import { useAuth } from '../contexts/AuthContext'
import { useEvents } from '../hooks/useEvents'
import { formatDateRange, getEventStatus } from '../utils/dateUtils'

const Home = () => {
    const navigate = useNavigate()
    const { user } = useAuth()
    const { events, loading, error, refetch } = useEvents()

    const handleViewEvent = (eventId) => {
        navigate(`/event/${eventId}`)
    }

    const handleNewEvent = () => {
        navigate('/newEvent')
    }

    return (
        <div className="p-8">
            {/* Main Content Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
                {/* Profile Banner Section */}
                <div>
                    <GlassPanel>
                        <ProfileBanner user={user} onNavigate={navigate} />
                    </GlassPanel>
                </div>

                {/* Upcoming Events Table */}
                <div>
                    <GlassPanel>
                        <h2 className="text-2xl font-bold mb-6" style={{color: 'var(--theme-text-primary)'}}>Upcoming Events</h2>
                        <EventsTable
                            events={events}
                            loading={loading}
                            error={error}
                            onViewEvent={handleViewEvent}
                            onNewEvent={handleNewEvent}
                            onRefresh={refetch}
                            formatDateRange={formatDateRange}
                            getEventStatus={getEventStatus}
                        />
                    </GlassPanel>
                </div>
            </div>

            {/* Timeline — past, present and upcoming on one scrubbable axis.
                Sits above the carousel because it is the navigational view of
                the whole passport, not a gallery. */}
            <div className="mb-8">
                <EventTimeline events={events} onEventClick={handleViewEvent} />
            </div>

            {/* Photo Carousel Section - Only shows if there are photos */}
            <div className="mb-8">
                <PhotoCarousel />
            </div>

            {/* Discovery lives on its own route now. The widget searches
                Ticketmaster on mount, so having it here spent a call against a
                rate-limited third-party key every time anyone opened the app. */}
            <div className="mb-8">
                <GlassPanel>
                    <div className="flex items-center justify-between gap-4 flex-wrap">
                        <div>
                            <h2 className="text-xl font-bold" style={{color: 'var(--theme-text-primary)'}}>
                                🎫 Looking for something to go to?
                            </h2>
                            <p className="text-sm mt-1" style={{color: 'var(--theme-text-secondary)'}}>
                                Browse upcoming shows near you
                            </p>
                        </div>
                        <button
                            onClick={() => navigate('/discover')}
                            className="bg-purple-600 hover:bg-purple-700 text-white font-medium py-2 px-5 rounded-lg transition-all duration-300"
                        >
                            Discover events →
                        </button>
                    </div>
                </GlassPanel>
            </div>
        </div>
    );
};

export default Home;